import axios, { AxiosResponse } from 'axios';
import { errorWrapper } from 'commerce/utils/network';
import { REVIEW_SOURCE_ID } from 'src/envVariables';
import { AverageRatingMerged, ReviewDTO, ReviewMerged } from './types';

const ResponseWrapper = <T>(response: AxiosResponse): Promise<T> => {
  const data = response?.data?.data;

  return { ...response, ...(!!data ? data : {}) };
};

/** This is proxy to our server. See next.config.js */
const getReviewUrl = (): string =>
  typeof window === 'undefined'
    ? `${process.env.REVIEW_SERVICE}/api`
    : `/api/review`;

export const sendReview: ReviewDTO = (referenceKey, locale, data) => {
  return errorWrapper<void>(sendReview.name, () =>
    axios.post(
      `/api/review/private/reviews/p-${referenceKey}/s-${REVIEW_SOURCE_ID}/l-${locale}`,
      data,
    ),
  );
};

/** This is proxy to our server. See next.config.js */

export const getReviewsMerged = (
  productReferenceKeys: string[],
  customParams?: { stars?: number; sort?: string; page?: number },
) => {
  return errorWrapper<ReviewMerged>(getReviewsMerged.name, async () => {
    const params = new URLSearchParams();

    /* For sending data in format:
      productReferenceKeys=productId&productReferenceKeys=productId
    */
    productReferenceKeys.forEach((key) =>
      params.append('productReferenceKeys', key),
    );

    if (customParams) {
      Object.entries(customParams).forEach(([key, value]) => {
        !!value && params.append(key, value.toString());
      });
    }

    !!REVIEW_SOURCE_ID && params.append('sourceIds', REVIEW_SOURCE_ID);

    const response = await axios.get(`${getReviewUrl()}/reviews/merged`, {
      params,
    });

    return ResponseWrapper<ReviewMerged>(response);
  });
};

export const getAverageRatingMerged = (productReferenceKeys: string[]) => {
  return errorWrapper<AverageRatingMerged>(
    getAverageRatingMerged.name,
    async () => {
      const params = new URLSearchParams();

      /* For sending data in format:
      productReferenceKeys=productId&productReferenceKeys=productId
    */
      productReferenceKeys.forEach((key) =>
        params.append('productReferenceKeys', key),
      );

      const response = await axios.get(
        `${getReviewUrl()}/average-ratings/merged`,
        {
          params,
        },
      );

      return ResponseWrapper<AverageRatingMerged>(response);
    },
  );
};
